import angular from 'angular';

angular.module('webTools').controller('LoginCtrl', ['$scope', '$location', 'Auth', 'ModalWindow', '$routeParams', 'Utility', '$ngRedux', '$window', '$cookies',
	function ($scope, $location, Auth, ModalWindow, $routeParams, Utility, $ngRedux, $window, $cookies) {

		const store = $ngRedux.getState();
		const clientSSO = $routeParams.ssoClientID;

		$scope.formData = {};
		$scope.webLink = Utility.buildWebLink($routeParams);

		if (!clientSSO) {
			if (Auth.loggedIn()) {
				Utility.getWebLinkPath($scope.webLink).then((res) => {
					$location.url(res.linkPath);
				})
			}
		}

		$scope.loginError = '';
		$scope.invalidLogin = false;
		$scope.loginSubmitted = false;
		$scope.showForgotPassword = false;

		$scope.isEdit = (typeof $routeParams.ssoServer !== 'undefined' && $routeParams.ssoServer !== '') && (typeof $routeParams.ssoRepo !== 'undefined' && $routeParams.ssoRepo != '');

		if ($cookies.get('loginError')) {
			$scope.loginError = $cookies.get('loginError');
			$scope.invalidLogin = true;
			$cookies.remove('loginError');
		}

		$scope.launchForgotPassword = function () {
			if ($scope.formData.server && $scope.formData.repository) {
				ModalWindow.openForgotPassword(function (user) {
					Auth.resetPassword(user, $scope.formData.server, $scope.formData.repository, function (res) {
						console.log(res)
						ModalWindow.openNotification(res.data.replace(/"/g, ""));
					})
				});
			} else {
				ModalWindow.openNotification('Please enter server name and repository.')
			}
		}

		$scope.loginOptions = [
			{ id: 1, value: 'SQL', text: 'SQL User', visible: !clientSSO },
			{ id: 2, value: 'windows', text: 'Current Windows User', visible: store.app.windowsAuth && !clientSSO },
			{ id: 3, value: 'differentWindows', text: 'Different Windows User', visible: !clientSSO },
			{ id: 4, value: 'office365', text: 'Microsoft Office 365', visible: store.app.ssoType != null },
		];

		// DEFAULT LOGIN OPTION :: 0 = SQL, 1 = CurrentNT, 2 = DifferentNT, 3 = Office 365 SSO
		if (!clientSSO) {
			$scope.selectedOption = $scope.loginOptions[$scope.defaultLoginOption];
		}
		else {
			$scope.selectedOption = $scope.loginOptions[3];
    }

		$scope.setLoginOption = function (option) {
			$scope.selectedOption = option;
			if ($scope.selectedOption.id === 1) {
				$scope.showForgotPassword = store.app.showForgotPassword;
			} else {
				$scope.showForgotPassword = false;
			}
		};

		if($scope.isEdit) {
			$scope.defaultServer = $routeParams.ssoServer;
			$scope.defaultRepository = $routeParams.ssoRepo;
		}

		// default form values
		$scope.setFormValues = function () {
			$scope.formData.user = $scope.defaultUser;
			$scope.formData.pass = '';
			$scope.formData.domain = $scope.defaultDomain;
			$scope.formData.server = $scope.defaultServer;
			$scope.formData.repository = $scope.defaultRepository;
			$scope.setLoginOption($scope.selectedOption);
		}

		$scope.setFormValues();

		$scope.showDomain = function () { return $scope.selectedOption.id === 3; }
		$scope.showUser = function () { return $scope.selectedOption.id !== 2 && $scope.selectedOption.id !== 4; }
		$scope.showPassword = function () { return $scope.selectedOption.id !== 2 && $scope.selectedOption.id !== 4; }

		$scope.showLoginOptions = false;
		$scope.showLoginForm = false;
		$scope.showMFA = false;

		if (store.app.autoLogin && $scope.enableAutoLogin) {

			Auth.login('auto', '', '', '', '', '', $scope.webLink, '',
				function (authorized, redirect, message) {

					if (!authorized) {
						$scope.invalidLogin = true;
						$scope.loginSubmitted = false;
						$scope.loginError = message;
						$scope.showLoginForm = true;
					} else {
						if(redirect) {
							$location.url(redirect);
						}
						else if ($routeParams.redirect) {
							var r = $routeParams.redirect;
							$location.url(r);
						} else {
							window.sendToDefaultView($ngRedux, $location, Auth);
						}
					}
					$scope.$emit('userUpdated');
					return;
				}
			)
		} else {
			$scope.showLoginForm = true;
		}

		$scope.callLogin = function (formData) {

			if (!formData.user && $scope.selectedOption.id !== 2 && $scope.selectedOption.id !== 4) { $scope.loginError = 'Please enter your username.'; $scope.invalidLogin = true; return; }
			if (!formData.pass && $scope.selectedOption.id !== 2 && $scope.selectedOption.id !== 4) { $scope.loginError = 'Please enter your password.'; $scope.invalidLogin = true; return; }
			if (!formData.server) { $scope.loginError = 'Please enter the server name.'; $scope.invalidLogin = true; return; }
			if (!formData.repository) { $scope.loginError = 'Please enter the repository name.'; $scope.invalidLogin = true; return; }
			if (!formData.domain && $scope.selectedOption.id === 3) { $scope.loginError = 'Please enter the domain name.'; $scope.invalidLogin = true; return; }

			$scope.invalidLogin = false;
			$scope.loginSubmitted = true;


			if ($scope.selectedOption.id === 4) { // HANDLE AZURE SSO

					if (store.app.ssoType === 'oidc') {
						const msalConfig = {
							auth: {
								clientId: store.app.clientId,
								authority: `https://login.microsoftonline.com/${store.app.tenantId}/`,
								redirectUri: new $window.URL($location.absUrl()).origin // get base URL
							},
							cache: {
								cacheLocation: "sessionStorage", // This configures where your cache will be stored
								storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
							}
						};

						const loginRequest = {
							scopes: ["User.Read"]
						};

						const myMSALObj = new msal.PublicClientApplication(msalConfig);

						myMSALObj.loginPopup(loginRequest).then((data) => {

							// handle thick client SSO
							if (clientSSO) {

								const clientId = $routeParams.ssoClientID;

								Auth.clientSSOLogin('oidc', clientId, formData.server, formData.repository, data.idToken, $scope.isEdit, (authorized, data) => {
									location.href = 'sso-complete.html'
								});
							}
              		else {
								Auth.login('oidc', '', '', '', formData.server, formData.repository, $scope.webLink, data.idToken, (authorized, redirect, message) => {

									if (!authorized) {
										$scope.invalidLogin = true;
										$scope.loginSubmitted = false;
										$scope.loginError = message;
									}
									else {
										if (redirect) {
											$location.url(redirect);
										}
										else if ($routeParams.redirect) {
											var r = $routeParams.redirect;
											$location.url(r);
										} else {
											window.sendToDefaultView($ngRedux, $location, Auth);
										}
									}
								});
              				}
						})
							.catch(error => {
							console.log(error)
							$scope.invalidLogin = true;
							$scope.loginSubmitted = false;
							$scope.loginError = "Login failed.";
							$scope.$apply();
						});
					}
					else if (store.app.ssoType === 'saml') {

						if (clientSSO) {
							const clientId = $routeParams.ssoClientID;

							let redirectUrl = `/login-saml.aspx?clientId=${clientId}&repository=${formData.repository}&server=${formData.server}`

							if ($scope.isEdit) {
									redirectUrl += '&isEdit=1'
              				}

							$window.location.href = redirectUrl;
						}
						else {

							let redirectUrl = `/login-saml.aspx?repository=${formData.repository}&server=${formData.server}&redirect=${encodeURIComponent($location.url())}`;
							$window.location.href = redirectUrl;
            			}
					}

			}
			else {
				Auth.login(
					$scope.selectedOption.value,
					formData.user,
					formData.pass,
					formData.domain,
					formData.server,
					formData.repository,
					$scope.webLink,
					'',
					function (authorized, redirect, message) {
						if (!authorized) { // BAD LOGIN
							if (message && message.toLowerCase().indexOf('password is expired') > -1) {
								ModalWindow.openChangePassword('Your password has expired.', function (newPass) {
									Auth.changePassword(formData.user,
										formData.pass,
										newPass,
										formData.domain,
										formData.server,
										formData.repository,
										function (a, r, m) {
											if (!a) {
												ModalWindow.openNotification(m, function () {
													$scope.invalidLogin = false;
													$scope.loginSubmitted = false;
												});
											} else {
												ModalWindow.openNotification('Password has been changed.', function () {
													if (redirect) {
														$location.url(redirect);
													}
													else if ($routeParams.redirect) {
														var r = $routeParams.redirect;
														$location.url(r);
													} else {
														window.sendToDefaultView($ngRedux, $location, Auth);

													}

													$scope.$emit('userUpdated');
												});
											}
										});
								}, function (submitted) {
									if (!submitted) {
										$scope.invalidLogin = false;
										$scope.loginSubmitted = false;
										$scope.$apply();
									}
								});
							} else { // not authorized
								$scope.invalidLogin = true;
								$scope.loginSubmitted = false;
								$scope.loginError = message;
							}
						} else { // SUCCESSFUL LOGIN

							if (redirect) {
								$location.url(redirect);
							}
							else if ($routeParams.redirect) {
								var r = $routeParams.redirect;
								$location.url(r);
							} else {
								window.sendToDefaultView($ngRedux, $location, Auth);
							}

						}
						$scope.$emit('userUpdated');
					}
				)
			}
		}
	}
]);